import React from "react";

const ArrowRight: React.FC<React.SVGProps<SVGSVGElement>> = ({ width = 24, height = 24, ...props }) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			role="img"
			aria-label="Arrow right icon"
			{...props}
		>
			<path
				d="M9.46973 5.96973C9.76262 5.67683 10.2374 5.67683 10.5303 5.96973L16.0303 11.4697C16.3232 11.7626 16.3232 12.2374 16.0303 12.5303L10.5303 18.0303C10.2374 18.3232 9.76262 18.3232 9.46973 18.0303C9.17683 17.7374 9.17683 17.2626 9.46973 16.9697L14.4395 12L9.46973 7.03027C9.17683 6.73738 9.17683 6.26262 9.46973 5.96973Z"
				fill="#23262A"
			/>
		</svg>
	);
};

export default ArrowRight;